/**
 * Serviceklassen im Chauffeur-Betrieb (KON-243). Ein Fahrzeug gehört zu einer Klasse, ein Auftrag verlangt eine. Die Disposition weist nur Fahrzeuge der verlangten Klasse zu: Ein Business-Fahrzeug
 * fährt keinen First-Class-Auftrag. Die Schlüssel entsprechen den Werten des Anfragefelds `vehicleClass` im Chauffeur-Profil, damit ein Auftrag aus der Anfrage seine Klasse mitbringt.
 */
export const SERVICE_CLASSES = ['business', 'first', 'van', 'hybrid', 'electric'];
export const SERVICE_CLASS_LABELS = {
    business: 'Business',
    first: 'First Class',
    van: 'Business Van',
    hybrid: 'Hybrid',
    electric: 'Business Elektro',
};
/**
 * Farben des Kennzeichens einer Klasse (Verlauf von hell nach dunkel): Business grün, First Class gold, Business Van violett, Hybrid türkis. Elektro hat kein Kreissymbol, sondern einen grünen Blitz,
 * `icon` nennt das Symbol, wo es eines gibt.
 */
export const SERVICE_CLASS_COLORS = {
    business: { from: '#4ade80', to: '#15803d', icon: null },
    first: { from: '#f0d08a', to: '#b8893a', icon: null },
    van: { from: '#c4b5fd', to: '#6d28d9', icon: null },
    hybrid: { from: '#5eead4', to: '#0f766e', icon: null },
    electric: { from: '#4ade80', to: '#15803d', icon: 'bolt' },
};
export function isServiceClass(value) {
    return typeof value === 'string' && SERVICE_CLASSES.includes(value);
}
/** Klasse aus dem Wert des Anfragefelds `vehicleClass`, null wenn leer oder unbekannt */
export function serviceClassOf(value) {
    return isServiceClass(value) ? value : null;
}
/** Passt ein Fahrzeug zur verlangten Klasse? Ohne Anforderung passt jedes, ohne Klasse am Fahrzeug passt keines zu einer Anforderung. */
export function classMatches(required, vehicle) {
    return !required || required === vehicle;
}
//# sourceMappingURL=service-classes.js.map